import VueI18n from 'vue-i18n'

import VueMapkit from 'vue-mapkit'

import SvgVue from 'svg-vue';

import en from "../../lang/platform/en";
import nl from "../../lang/platform/nl";
import es from "../../lang/platform/es";
import pt from "../../lang/platform/pt";
import fr from "../../lang/platform/fr";
import de from "../../lang/platform/de";


window.Vue = require('vue').default;

import CountryFlag from 'vue-country-flag'

import { LMap, LTileLayer, LMarker, LIcon,  } from "vue2-leaflet";
import VueLoadImage from 'vue-load-image'
import Vue from 'vue';

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);
Vue.use(SvgVue);

import checkView from 'vue-check-view'
Vue.use(checkView)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const i18n = new VueI18n({
    locale: document.documentElement.lang,
    fallbackLocale: process.env.DEFAULT_LANGUAGE,
    seo: true,
    messages: {
        en, nl, es, pt, fr, de
    }
})

!(('ontouchstart' in window) && !(navigator.msMaxTouchPoints > 0)) ? document.querySelector('body').classList.add('no_touch') : null;

Vue.prototype.$appName = process.env.APP_NAME
Vue.prototype.$main_color = getComputedStyle(document.body).getPropertyValue("--main_color");
Vue.prototype.$main_color_darkmode = getComputedStyle(document.body).getPropertyValue("--dark-main_color");
Vue.prototype.$main_color_bright = getComputedStyle(document.body).getPropertyValue("--main_color_bright");
Vue.prototype.$main_color_brighter = getComputedStyle(document.body).getPropertyValue("--main_color_brighter");
Vue.prototype.$sub_color = getComputedStyle(document.body).getPropertyValue("--sub_color");
Vue.prototype.$third_color = getComputedStyle(document.body).getPropertyValue("--third_color");

Vue.prototype.$dark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
Vue.prototype.$baseUrl = window.location.protocol + "//" + window.location.host;
Vue.prototype.$homeUrl = document.documentElement.getAttribute('default_lang') == document.documentElement.lang ? Vue.prototype.$baseUrl : window.location.protocol + "//" + window.location.host + "/" + document.documentElement.lang;
Vue.prototype.$termsUrl = Vue.prototype.$homeUrl + "/termsandconditions"
Vue.prototype.$path = window.location.pathname + window.location.search + window.location.hash;

Vue.prototype.$BMB_API = process.env.MIX_APP_LOCAL ? 'https://boostmybookings.test/' : 'https://boostmybookings.com/';
Vue.prototype.$clientID = window.clientID;


Vue.use(CountryFlag);

Vue.component(
    'l-map',
    LMap
);
Vue.component(
    'l-tile-layer',
    LTileLayer
);
Vue.component(
    'l-marker',
    LMarker
);
Vue.component(
    'l-icon',
    LIcon
);

Vue.component(
    'event_schedule',
    require('./components/elements/event_schedule.vue').default
)

Vue.component(
    'live_location_ask',
    require('./components/elements/live_location_ask.vue').default
)

Vue.component(
    'cookiebar',
    require('./components/elements/cookiebar.vue').default
)

Vue.component(
    'timetable',
    require('./components/elements/timetable.vue').default
)

Vue.component(
    'notification',
    require('./components/elements/notification.vue').default
)

Vue.component(
    'vue-load-image',
    VueLoadImage
);

Vue.component(
    'check_tickets_availability',
    require('./components/elements/check_tickets_availability.vue').default
);

Vue.component(
    'app_dropdown',
    require('./components/elements/dropdown/AppDropdown.vue').default
);

Vue.component(
    'app_modal',
    require('./components/elements/modal/Modal.vue').default
);

Vue.component(
    'app_dropdown_content',
    require('./components/elements/dropdown/AppDropdownContent.vue').default
);

Vue.component(
    'home_acco',
    require('./components/home_acco.vue').default
);

Vue.component(
    'appAccordion',
    require('./components/elements/appAccordion.vue').default
)

Vue.component(
    'likebutton',
    require('./components/elements/likebutton.vue').default
);

Vue.component(
    'filterbar',
    require('./components/elements/filterbar.vue').default
);

Vue.component(
    'filtermenu',
    require('./components/elements/filtermenu.vue').default
);

Vue.component(
    'home_recently_viewed',
    require('./components/home_recently_viewed.vue').default
)

Vue.component(
    'accomodation_lister_compact',
    require('./components/accomodation_lister_compact.vue').default
);

Vue.component(
    'navbar',
    require('./components/elements/navbar.vue').default
)

Vue.component(
    'navbar_button',
    require('./components/elements/navbar_button.vue').default
)

Vue.component(
    'events_filter_modal',
    require('./components/elements/events_filter_modal.vue').default
)

Vue.component(
    'accomodation_lister_map',
    require('./components/accomodation_lister_map.vue').default
);

Vue.component(
    'accomodation_lister',
    require('./components/accomodation_lister.vue').default
);

Vue.component(
    'acco_page',
    require('./components/acco_page.vue').default
);

Vue.component(
    'acco_houserules',
    require('./components/acco_houserules.vue').default
);

Vue.component(
    'acco_policy',
    require('./components/acco_policy.vue').default
)

Vue.component(
    'search_results',
    require('./components/searchbox/search_results.vue').default
)

Vue.component(
    'acco_searchbutton_nav',
    require('./components/searchbox/acco_searchbutton_nav.vue').default
)

Vue.component(
    'small_mobile_search_button',
    require('./components/searchbox/small_mobile_search_button.vue').default
)

Vue.component(
    'booking_box',
    require('./components/bookingbox.vue').default
)

Vue.component(
    'acco_searchbox',
    require('./components/searchbox/acco_searchbox.vue').default
)

Vue.component(
    'acco_searchbox_location',
    require('./components/searchbox/acco_searchbox_location.vue').default
)

Vue.component(
    'acco_searchbox_calendar',
    require('./components/searchbox/acco_searchbox_calendar.vue').default
)

Vue.component(
    'acco_searchbox_guests',
    require('./components/searchbox/acco_searchbox_guests.vue').default
)

Vue.component(
    'portimao_text',
    require('./components/portimao_text.vue').default
)

Vue.component(
    'share-button',
    require('./components/elements/sharebutton.vue').default
)

Vue.component(
    'subscriber_signup',
    require('./components/elements/subscriber_signup.vue').default
)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

new Vue({
    el: '#app',
    i18n,
});